<template>
  <div>
    <two-integrations :integration1="integration1" :integration2="integration2" :loading="false"/>
    <div class="tile my-4">
      <div class="form_row pb-4 border-b border-40">
        <div class="px-8">
          <h2 class="h4">{{ trans('dashboard.integrations.overview.subtitle') }}</h2>
        </div>
        <div class="px-8">
          <inertia-link
            v-if="$can('flows.update')"
            :href="$route('dashboard.user.integrations.configure_flows', {user: user.id, integration: this.$route().params.integration})"
            class="button button_success">
            {{ trans('dashboard.integrations.overview.configure_flows') }}
          </inertia-link>
        </div>
      </div>
      <div class="flex flex-col py-8">
        <div v-if="selectedFlows.length" class="grid-3">
          <div v-for="(flow, idx) in selectedFlows" :key="idx"
               class="tile tile_flow mx-3 text-center overflow-hidden"
               :class="[canViewFlowOverview ? 'cursor-pointer' : 'cursor-not-allowed']"
               @click="handleRedirect(flow)">
            <div class="px-8 tile_column">
              <h3 class="h5">{{ flow['first_flow'].group.translated_name }}</h3>
            </div>
            <div class="tile_bar">
              <template v-if="flow !== null">
                <flow-status :flow="flow"></flow-status>
              </template>
              <button
                v-if="$can('flows.delete')"
                class="tile-button has-tooltip"
                @click="handleConfirmDeleteFlow(flow, $event)"
              >
                <svg class="icon">
                  <use xlink:href="#delete-icon"></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div v-else class="px-8">
          <p>{{ trans('dashboard.integrations.overview.no_flows') }}</p>
        </div>
      </div>
    </div>
    <confirm-delete-modal
      v-if="deleteModal"
      @confirm="handleDeleteFlow"
      @close="deleteModal = false"
      :header="trans('dashboard.integrations.overview.delete_flow_confirmation_title')"
      :content="trans('dashboard.integrations.overview.delete_flow_confirmation_description')"
    />
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import Swal from "sweetalert2";
import DashboardLayout from "@/Layouts/DashboardLayout"
import IntegrationLayout from "@/Layouts/IntegrationLayout"
import TwoIntegrations from "@/components/Dashboard/TwoIntegrations"
import FlowStatus from "@/components/Dashboard/FlowStatus";
import ConfirmDeleteModal from "@/components/Dashboard/ConfirmDeleteModal";

export default {
  name: "IntegrationOverview",

  layout: [DashboardLayout, IntegrationLayout],

  components: {
    TwoIntegrations,
    FlowStatus,
    ConfirmDeleteModal
  },

  props: {
    user: Object
  },

  data: () => ({
    deleteModal: false,
    toDeleteFlow: null,
  }),

  computed: {
    ...mapGetters('integrationDetails', ['integration1', 'integration2', 'flows']),

    selectedFlows() {
      return _.filter(this.flows, flow => flow.is_selected);
    },

    canViewFlowOverview() {
      return this.$can('flows.overview.view|flows.overview.update');
    }
  },

  methods: {
    handleRedirect(flow) {
      if (!this.canViewFlowOverview) {
        return;
      }

      this.$inertia.visit(
        this.$route('dashboard.user.integrations.flows.overview', {
          user: this.user.id,
          integration: flow.user_integration_id,
          integrationFlow: flow.id
        })
      )
    },

    handleConfirmDeleteFlow(flow, event) {
      event.stopPropagation();
      this.toDeleteFlow = flow;
      this.deleteModal = true;
    },

    async handleDeleteFlow() {
      await axios
        .delete(`/user/${this.user.id}/integration/flows/${this.toDeleteFlow.id}`)
        .then(() => {
          Swal.fire({
            text: this.trans('dashboard.alerts.success_delete_flow'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });

          const flows = this.flows.map(flow => {
            if (this.toDeleteFlow.id === flow.id) {
              flow.is_selected = false;
            }
            return flow;
          });

          this.storeIntegrationData({
            flows: flows,
          });
        })
        .catch(err => {
          Swal.fire({
            text: err.data.message,
            icon: 'error',
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
  },
}
</script>

<style scoped lang="scss">
.group {
  &-name {
    flex-basis: 90%;
  }

  &-status {
    flex-basis: 10%;
  }

  &-buttons {
    flex-basis: 5%;
  }
}

.tile {
  &_flow {
    grid-template-columns: 1fr 4.5rem;
    padding: 0;
  }
}
</style>
